import type { SkuBenchmark, SkuUsage } from '../../data/analytics';
import type { Endpoint } from '../../features/catalog/model';
import { EndpointRow } from './EndpointRow';
import { m } from '../../paraglide/messages';

export interface EndpointTableProps {
  apiId: string;
  /** endpoints, pre-sorted by real requests desc */
  endpoints: Endpoint[];
  /** per-category color token */
  color: string;
  usage: Record<string, SkuUsage>;
  benchmarks: Record<string, SkuBenchmark>;
}

/** The endpoint table, with no section header above it: the column labels are
 *  the heading, so the list starts as high as the page header allows, and the
 *  `requests / mo` column read top to bottom already shows the order the table
 *  is sorted in. The prose that used to sit here lives below the table. */
export const EndpointTable = ({
  apiId,
  endpoints,
  color,
  usage,
  benchmarks,
}: EndpointTableProps) => {
  const single = endpoints.every((e) => e.providers.length === 1);
  return (
    <div className="overflow-hidden rounded-12 border border-rule">
      <div className="mono hidden grid-cols-[minmax(0,1.6fr)_128px_112px_96px_182px_22px] gap-4.5 rounded-t-12 border-b border-rule bg-wash px-5 py-3 text-12 text-text-3 lg:grid">
        <span>{m.platform_table_endpoint()}</span>
        <span>{m.platform_table_requests()}</span>
        <span>{m.platform_table_health()}</span>
        <span>{single ? m.platform_table_provider() : m.platform_table_providers()}</span>
        <span className="text-right">{single ? m.platform_table_price() : m.platform_table_cheapest()}</span>
        <span />
      </div>
      {endpoints.map((ep, i) => (
        <EndpointRow
          key={ep.id}
          apiId={apiId}
          endpoint={ep}
          index={i}
          color={color}
          usage={usage[ep.sku]}
          benchmark={benchmarks[ep.sku]}
        />
      ))}
    </div>
  );
};
